module.exports = new __parcel__URL__("incapacitate.420d5ca6.png").toString();